<!--
  --
  -- フッタリンクリスト コンポーネント
  --
  -->
<template>
  <v-row tag="nav" justify="center" no-gutters>
    <c-item
      v-for="(link, index) in links"
      :key="index"
      :link="link"
    />
  </v-row>
</template>

<script>
import CItem from './CItem'

export default {
  name: 'CNav',
  components: {
    CItem
  },
  props: {
    links: {
      type: Array,
      required: true
    }
  }
}
</script>
